import {
    arrow,
    autoUpdate,
    flip,
    FloatingArrow,
    offset,
    Placement,
    shift,
    useDismiss,
    useFloating,
    useInteractions
} from '@floating-ui/react';
import React, { useLayoutEffect, useRef, useState } from 'react';

export const ThresholdsEditPopup = (props: {
    reference?: HTMLElement;
    boundary?: HTMLElement;
    children?: React.ReactNode;
    placement?: Placement;
    onClose?: () => void;
}) => {
    const [floating, setRef] = useState<HTMLElement | null | undefined>(undefined);
    const [reference, setRef2] = React.useState<HTMLElement | undefined>(undefined);
    const arrowRef = useRef<SVGSVGElement | null>(null);

    useLayoutEffect(() => {
        setRef2(props.reference);
    }, [props.reference]);

    const { floatingStyles, context } = useFloating({
        open: true,
        placement: props.placement ?? 'bottom',
        onOpenChange: (open) => {
            if (!open) {
                props.onClose?.();
            }
        },
        elements: {
            reference: reference,
            floating: floating
        },
        middleware: [
            offset({ mainAxis: 11 }),
            flip({ boundary: props.boundary, fallbackPlacements: ['left', 'right'] }),
            shift({ boundary: props.boundary }),
            arrow({ element: arrowRef })
        ],
        whileElementsMounted: autoUpdate
    });

    const dismiss = useDismiss(context);
    const { getFloatingProps } = useInteractions([dismiss]);

    return (
        <div
            ref={setRef}
            style={{ ...floatingStyles, backgroundColor: 'light-dark(white, var(--color-neutral-050))' }}
            className="border rounded-2 p-2 z-4"
            {...getFloatingProps()}>
            <FloatingArrow
                ref={arrowRef}
                context={context}
                fill="light-dark(white, var(--color-neutral-050))"
                width={20}
                height={10}
                stroke="var(--border-color)"
                strokeWidth={1}
            />
            {props.children}
        </div>
    );
};
